export default "__VITE_ASSET__CwFta8NO__"